import React from 'react'

const RestrictContentError = () => (
  <div className="mb-6">
    Restrict content by region.
  </div>
)

export default RestrictContentError